module.exports = __webpack_public_path__ + "static/img/4-4.8f66db67.png";